/* global Swiper */
'use strict'
const sliders = {
	el: {
		sliderContainer: document.querySelectorAll('.js-slider')
	},

	fxInitSlider(slider) {
		const sliderCentered = slider.dataset.sliderCentered && JSON.parse(slider.dataset.sliderCentered),
			sliderDelay = slider.dataset.sliderDelay && JSON.parse(slider.dataset.sliderDelay),
			sliderLoop = slider.dataset.sliderLoop && JSON.parse(slider.dataset.sliderLoop),
			sliderAutoPlay = slider.dataset.sliderAutoplay && JSON.parse(slider.dataset.sliderAutoplay),
			sliderSizeWide = slider.dataset.sliderWide && JSON.parse(slider.dataset.sliderWide),
			sliderSizeLarge = slider.dataset.sliderLarge && JSON.parse(slider.dataset.sliderLarge),
			sliderSizeMedium = slider.dataset.sliderMedium && JSON.parse(slider.dataset.sliderMedium),
			sliderSizeSmall = slider.dataset.sliderSmall && JSON.parse(slider.dataset.sliderSmall),
			sliderPaginationType = slider.dataset.sliderPaginationType && slider.dataset.sliderPaginationType,
			sliderSpaceBetween = slider.dataset.sliderSpaceBetween && JSON.parse(slider.dataset.sliderSpaceBetween),
			sliderOnInteraction = slider.dataset.sliderOnInteraction && JSON.parse(slider.dataset.sliderOnInteraction),
			sliderNoSwipe = slider.dataset.sliderNoSwipe && JSON.parse(slider.dataset.sliderNoSwipe),
			sliderFreeMode = slider.dataset.sliderFreemode && JSON.parse(slider.dataset.sliderFreemode),
			sliderFreeModeSticky = slider.dataset.sliderFreemodeSticky && JSON.parse(slider.dataset.sliderFreemodeSticky),
			sliderKeyboard = slider.dataset.sliderKeyboard && JSON.parse(slider.dataset.sliderKeyboard),
			sliderMouseWheel = slider.dataset.sliderMousewheel && JSON.parse(slider.dataset.sliderMousewheel),
			sliderScroll = slider.dataset.sliderScroll && JSON.parse(slider.dataset.sliderScroll),
			sliderSpeed = slider.dataset.sliderSpeed && JSON.parse(slider.dataset.sliderSpeed),
			slidesPerGroup = slider.dataset.sliderGroup && JSON.parse(slider.dataset.sliderGroup),
			sliderDirection = slider.dataset.sliderDirection && slider.dataset.sliderDirection

		const swiperOptions = {
			slidesPerView: sliderSizeSmall ? sliderSizeSmall : 1,
			centeredSlides: sliderCentered ? sliderCentered : false,
			centeredSlidesBounds: sliderCentered ? true : false,
			loop: sliderLoop && slider.querySelectorAll('.swiper-slide').length > 1 ? sliderLoop : false,
			spaceBetween: sliderSpaceBetween ? sliderSpaceBetween : 0,
			noSwiping: sliderNoSwipe ? sliderNoSwipe : false,
			speed: sliderSpeed ? sliderSpeed : 300,
			freeMode: sliderFreeMode ? sliderFreeMode : false,
			freeModeSticky: sliderFreeMode && sliderFreeModeSticky ? sliderFreeModeSticky : false,
			slideToClickedSlide: sliderFreeMode ? true : false,
			slidesPerGroup: slidesPerGroup ? slidesPerGroup : 1,
			direction: sliderDirection ? sliderDirection : 'horizontal',
			mousewheel: sliderFreeMode ? {
				releaseOnEdges: true
			} : sliderMouseWheel ? sliderMouseWheel : false,

			keyboard: {
				enabled: sliderKeyboard ? sliderKeyboard : false
			},

			navigation: {
				nextEl: slider.querySelector('.swiper-button-next'),
				prevEl: slider.querySelector('.swiper-button-prev')
			},

			pagination: {
				el: slider.querySelector('.swiper-pagination'),
				clickable: sliderPaginationType ? false : true,
				type: sliderPaginationType ? sliderPaginationType : 'bullets' //"bullets", "fraction", "progressbar" or "custom"  (default:"bullets")
			},

			scrollbar: {
				el: sliderScroll ? sliderScroll : null,
				hide: sliderScroll && true
			},

			autoplay: sliderAutoPlay ? {
				delay: sliderDelay ? sliderDelay : 5000,
				disableOnInteraction: sliderOnInteraction ? sliderOnInteraction : false
			} : false,

			breakpoints: {
				768: { //tablet up
					slidesPerView: sliderSizeMedium ? sliderSizeMedium : sliderSizeSmall ? sliderSizeSmall : 1
				},
				1024: { //small desktop up
					slidesPerView: sliderSizeLarge ? sliderSizeLarge : sliderSizeMedium ? sliderSizeMedium : sliderSizeSmall ? sliderSizeSmall : 1
				},
				1440: { // desktop up
					slidesPerView: sliderSizeWide ? sliderSizeWide : sliderSizeLarge ? sliderSizeLarge : sliderSizeMedium ? sliderSizeMedium : sliderSizeSmall ? sliderSizeSmall : 1
				}
			},

			on: {
				init: () => setTimeout(() => window.dispatchEvent(new Event('resize')), 100)
			}
		}

		new Swiper(slider, swiperOptions)
	},

	init() {
		for (const slider of this.el.sliderContainer)
			this.fxInitSlider(slider)
	}
}
sliders.init()